import messages from "../messages/messages.js";
import {EyeIcon, InformationCircleIcon} from "@heroicons/react/24/solid";

export function ContentLocked() {
    return (
        <div className="p-6 text-yellow-800 rounded-lg bg-yellow-50">
            <div className="flex items-center">
                <InformationCircleIcon className="w-5 h-5 mr-2"/>
                <h3 className="text-lg m-0 text-yellow-800 leading-none">Content locked</h3>
            </div>
            <div className="text-sm mt-2 mb-2">
                Content is locked because you are not a subscriber. Become a subscriber to
                support us and unlock all content.
            </div>
            <a href='/subscribe'
               className="text-white bg-yellow-800 hover:bg-yellow-900 font-medium rounded-lg text-xs px-3 py-1.5 text-center inline-flex items-center">
                <EyeIcon className="w-4 h-4 mr-2"/>
                Subscribe
            </a>
        </div>
    )
}